<ndt-add-blocked-phone-number-view
   [callState]="callState | async"
   [form]="form"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
   (saveAndAddAnother)="onCreateAndAddAnother()"
>
</ndt-add-blocked-phone-number-view>
